var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "buttons" }, [
    _c(
      "button",
      {
        staticClass: "print no_print",
        attrs: { title: "Печатная версия" },
        on: { click: _vm.printHtml },
      },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "pdf no_print",
        attrs: { title: "Скачать в PDF" },
        on: { click: _vm.downloadPdf },
      },
      [_vm._m(1)]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "uk-icon-print" })])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "uk-icon-file-pdf-o" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }